import styled from 'styled-components';

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-weight: 400;
    margin-top: -2px;

    [data-variant='body-sm']:last-child {
        text-transform: capitalize;
        font-size: 14px;
        color: #5a5a5a;
    }

    h3 {
        margin-bottom: 0;
    }
`;
